// Copyright (c) Docugami, Inc. All rights reserved.

import { TooltipHost, TooltipDelay, IconButton } from "@fluentui/react";

interface FilterIconButtonProps {
    disabled?: boolean;
    onClick?: () => void;
}

export const FilterIconButton = (props: FilterIconButtonProps): JSX.Element => {
    return (
        <TooltipHost content="Filters" calloutProps={{ isBeakVisible: false }} delay={TooltipDelay.zero}>
            <IconButton disabled={props.disabled} styles={{ icon: { fontSize: '16px' } }} iconProps={{ iconName: 'Filter' }} onClick={props.onClick} />
        </TooltipHost>
    )
}